import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ClearCircleSmall = (props: SvgIconT.Props) => (
  <SvgIcon width={16} height={16} {...props} viewBox="0 0 16 16">
    <g fillRule="evenodd" stroke="none" strokeWidth="1">
      <path
        d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0L8,0z M15.2,8c0,3.9-3.2,7.2-7.2,7.2S0.8,11.9,0.8,8
	S4.1,0.8,8,0.8S15.2,4.1,15.2,8L15.2,8z"
      ></path>
      <polygon points="11,11.6 8,8.6 5,11.6 4.4,11 7.4,8 4.4,5 5,4.4 8,7.4 11,4.4 11.6,5 8.6,8 11.6,11 "></polygon>
    </g>
  </SvgIcon>
);

export default ClearCircleSmall;
